module.exports = __webpack_public_path__ + "static/media/homepage-overlay-3.0d0c5c76.jpg";